module.exports = __webpack_public_path__ + "static/media/newLogo.3a889807.png";